export class RecordKPRConstants {
  public static readonly PageTitle: string = 'RecordKPR';
  public static readonly Warning_Message: string = 'Outputs generated by RecordKPR must not be considered final or authoritative without independent verification.';
  public static readonly Placeholder_Text: string = 'Ask RecordKPR anything...';
  public static readonly New_Chat_Button: string = 'New Chat';
  public static readonly Welcome_Title: string = 'Welcome to RecordKPR';
  public static readonly Initial_Message: string = 'Hello! I am RecordKPR, your AI assistant. How can I help you today?';
  public static readonly Typing_Indicator_Text: string = 'RecordKPR is thinking';
  public static readonly Agent_Busy_Message: string = 'Our AI assistant is currently busy processing requests. Please try again in a few moments. We appreciate your patience!';
  public static readonly RecordKPR_Page_Validation: string = 'You do not have access to this page.';

}
